<template>
  <div class="w-full h-full">
    <div
      @click="images.loaders ? void 0 : $emit('removeImagePreview')"
      class="close-modal w-[25px] h-[25px] bg-white flex items-center justify-center rounded-full absolute left-5 top-3 z-[60]"
    >
      <fai class="text-theme-primary" icon="xmark" />
    </div>

    <img class="w-full h-full object-cover" :src="images.imagePreview" />

    <div
      @click="images.loaders ? void 0 : $emit('sendImage')"
      class="send-image w-[65px] h-[65px] absolute bottom-10 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-theme-primary drop-shadow-md flex items-center justify-center rounded-full"
    >
      <Vue3Lottie
        v-if="!images.loaders"
        class="!w-[65px] !h-[65px]"
        :loop="true"
        :animationData="ImageSend"
      />

      <Loader inner v-else></Loader>
    </div>
  </div>
</template>
<script setup>
  import ImageSend from "/public/assets/lotties/image_send.json"
  import { computed } from "vue"

  const props = defineProps({
    images: {
      type: Object,
      required: true,
      default: {},
    },
  })

  const getImageSizeFromBase64 = (base64String) => {
    // header'ı ayıkla
    const base64 = base64String.split(",")[1]
    const sizeInBytes =
      (base64.length * 3) / 4 -
      (base64.endsWith("==") ? 2 : base64.endsWith("=") ? 1 : 0)
    const sizeInKB = sizeInBytes / 1024
    return `${sizeInKB.toFixed(2)} KB`
  }

  // const imageSize = computed(() => {
  //   if (!props.images?.imagePreview) return ""
  //   return getImageSizeFromBase64(props.images.imagePreview)
  // })
</script>
